import { LogIn, FileKey2, Braces } from 'lucide-react';

import { CredentialTypeEnum } from 'src/graphql/schema';

import LoginForm from '../ui/forms/LoginForm';
import CryptographicKeyForm from '../ui/forms/CryptographicKeyForm';
import ApiCredentialsForm from '../ui/forms/ApiCredentialsForm';

export const credentialFormContentMap = {
  [CredentialTypeEnum.Login]: {
    title: 'Add new Login',
    description: 'Enter the username and password required to access your accounts.',
    form: LoginForm,
    icon: LogIn,
  },
  [CredentialTypeEnum.CryptographicKey]: {
    title: 'Add new Cryptographic key',
    description: 'Paste the public SSH key that will be used to authenticate access.',
    form: CryptographicKeyForm,
    icon: FileKey2,
  },
  [CredentialTypeEnum.ApiCredentials]: {
    title: 'Add new API credentials',
    description: 'Enter the credentials required to authenticate API access.',
    form: ApiCredentialsForm,
    icon: Braces,
  },
};
